module.exports = __webpack_public_path__ + "static/media/home-students@2x.53a03a9f.png";